module.exports = __webpack_public_path__ + "static/media/IMG_9517.7d644ddc.JPG";